// extracted by mini-css-extract-plugin
export default {"ErrorMessage":"MaxAnswersMessage_ErrorMessage__UMZce"};